import React from "react";
import { THEME_PREFERENCES, useThemePreference } from "../theme/ThemePreference.jsx";

const LABELS = { system: "System", light: "Light", dark: "Dark" };

function ThemeIcon({ theme }) {
  if (theme === "dark") return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.4 15.3A8.5 8.5 0 0 1 8.7 3.6 8.5 8.5 0 1 0 20.4 15.3Z" /></svg>;
  return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="3.5" /><path d="M12 2v2m0 16v2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M2 12h2m16 0h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></svg>;
}

export default function ThemeSelector() {
  const { preference, effectiveTheme, setPreference } = useThemePreference();
  const [open, setOpen] = React.useState(false);
  const containerRef = React.useRef(null);

  React.useEffect(() => {
    if (!open) return undefined;
    const closeOnOutsideClick = (event) => { if (!containerRef.current?.contains(event.target)) setOpen(false); };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
        containerRef.current?.querySelector("button")?.focus();
      }
    };
    document.addEventListener("pointerdown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [open]);

  return (
    <div className="theme-selector" ref={containerRef}>
      <button className="theme-selector__trigger" type="button" aria-label={`Theme: ${LABELS[preference]}`} aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen((value) => !value)}>
        <span className={`theme-selector__icon theme-selector__icon--${effectiveTheme}`}><ThemeIcon theme={effectiveTheme} /></span>
      </button>
      {open ? (
        <div className="theme-selector__menu" role="menu" aria-label="Theme preference">
          <span className="theme-selector__title">Theme</span>
          {THEME_PREFERENCES.map((theme) => (
            <button key={theme} type="button" role="menuitemradio" aria-checked={preference === theme} className="theme-selector__option" onClick={() => { setPreference(theme); setOpen(false); }}>
              <span className="theme-selector__radio" aria-hidden="true" />
              <span>{LABELS[theme]}</span>
              {theme === "system" ? <span className="theme-selector__hint">Auto</span> : null}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
